import {useTranslation} from 'react-i18next';
import ICON_KAKAO from '../../../public/static/auth/login-ico-sns-kakao.svg';
import Text from '../../common/component/Text';
import TextButton from '../../common/component/TextButton';
import useTypedSelector from '../../common/hook/useTypedSelector';

interface IProps {
  showDaumAuthLink: boolean;
  isEmptyTitle: boolean;
  onClickLogin: () => void;
  onClickLoginDirect: () => void;
  onClickIntegration: () => void;
}

export default function KakaoAuth({
  showDaumAuthLink,
  isEmptyTitle,
  onClickLogin,
  onClickLoginDirect,
  onClickIntegration,
}: IProps) {
  const {t} = useTranslation();
  const [isMobile] = useTypedSelector(state => [
    !!state.common.userAgent?.isMobile,
  ]);
  return (
    <div
      className={cn('w-full', {
        'mt-20': !isEmptyTitle,
        'mt-30': isEmptyTitle,
      })}
    >
      {isMobile && (
        <TextButton
          width="100%"
          height="50px"
          className="btn-kakao-yellow"
          textClassName="s16-bold-black flex-center"
          onClick={onClickLogin}
        >
          <img
            src={ICON_KAKAO}
            alt=""
            width={24}
            height={24}
            className="mr-5"
          />
          {t('login_korea_kakao')}
        </TextButton>
      )}
      <TextButton
        width="100%"
        height="50px"
        textClassName="s16-bold-grey13"
        className={cn('btn-transparent-grey-06', {'mt-10': isMobile})}
        onClick={onClickLoginDirect}
      >
        {t('login_korea_kakao_enter')}
      </TextButton>
      {showDaumAuthLink && (
        <Text
          className="s13-regular-grey06 mt-24 mb-2 underline"
          onClick={onClickIntegration}
        >
          {t('login_korea_daum')}
        </Text>
      )}
    </div>
  );
}
